@for (ec of employmentClassifications; track ec) {
  <psv-personprofile-edit-classifications
    [classifications]="ec" [header]="getFieldsetLabel(ec)"
    [researchAreaDdKey]="'cs.psv.person.profile.classification.employment.researchArea'"
    [researchAreaKdsfDdKey]="'cs.psv.person.profile.classification.employment.researchAreaKdsf'"
    [subjectAreaDdKey]="'cs.psv.person.profile.classification.employment.subjectArea'">
  </psv-personprofile-edit-classifications>
}
